import { render } from "./index.vue?vue&type=template&id=0aa2e041&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0aa2e041&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@https+++registry.npmmirror.com+vue-loader+-+vue-loader-17.4.2.tgz_vue@3.2.13_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa2e041"]])

export default __exports__